import React from "react";
//#region  types
import { WintSuperkollAPIModelExportItems, WintUtilsWebApi } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { TableEnums } from "models/enums";
import { User } from "models/propTypes/userProfilePropTypes";
import { IconDefinitionConstants } from "utils/constants";
import { ExportedFilesFormTypes } from "models/formTypes";
//#endregion
//#region Components
import { Icon, RoundButton, TableAsync, useFilterContext } from "components/common";
import ExportItemStatusTags from "./statusTags";
import { useExportItemService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ExportedFilesList: React.FC = (props) => {
  const exportItemsService = useExportItemService();
  const { filter } = useFilterContext<ExportedFilesFormTypes.ExportItemsFilter>();

  const filterFunc = React.useMemo(
    () => (baseFilter: WintUtilsWebApi.Filter) => exportItemsService.reportFilter(baseFilter, filter),
    [filter]
  );

  const onDownloadButtonClick = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    exportItemsService.downloadExportedFile(id);
  };

  return (
    <TableAsync<WintSuperkollAPIModelExportItems.ExportItem>
      properties={{
        created: {
          description: TranslationKeys.Common.Created,
          formatter: (item: WintSuperkollAPIModelExportItems.ExportItem) =>
            item.created ? new Date(item.created) : undefined,
          noWrap: true,
          classification: "date",
        },
        initiatedById: {
          description: TranslationKeys.Common.CreatedBy,
          formatter: (item: WintSuperkollAPIModelExportItems.ExportItem) =>
            item.initiatedById ? new User(item.initiatedById, item.initiatedByName ?? "") : undefined,
          noWrap: true,
        },
        state: {
          description: TranslationKeys.Common.Status,
          formatter: (item: WintSuperkollAPIModelExportItems.ExportItem) => (
            <ExportItemStatusTags status={item.state} />
          ),
          noWrap: true,
        },
        id: {
          description: TranslationKeys.Common.Download,
          formatter: (item: WintSuperkollAPIModelExportItems.ExportItem) =>
            item.id && item.state === WintSuperkollAPIModelExportItems.ExportItemState.Done ? (
              <RoundButton className={cssExports.tableIconButton} onClick={onDownloadButtonClick.bind(null, item.id)}>
                <Icon icon={IconDefinitionConstants.WDownload} />
              </RoundButton>
            ) : undefined,
          alignment: "center",
          width: 50,
        },
      }}
      filter={filterFunc}
      pagination={"advanced"}
      maxRowCount={10}
      hidePaginationIfSinglePage
      tableId={TableEnums.TableType.ExportItemsList}
    />
  );
};
export default ExportedFilesList;
